import { cn } from '@/lib/utils';
import { getDemographicsSectionTitle } from '../facesheetOutputNormalizer';
import type { FacesheetDemographicsData } from '../types';

interface FacesheetDemographicsCardProps {
  data: FacesheetDemographicsData;
  anchorRef?: (element: HTMLElement | null) => void;
  className?: string;
}

export const FacesheetDemographicsCard = ({
  data,
  anchorRef,
  className,
}: FacesheetDemographicsCardProps) => {
  return (
    <section
      ref={anchorRef}
      id="section-demographics"
      tabIndex={-1}
      aria-labelledby="section-demographics-title"
      className={cn('space-y-3', className)}
    >
      <h2
        id="section-demographics-title"
        className="pl-1 text-2xl leading-none font-medium text-black"
      >
        {getDemographicsSectionTitle(data.fidelity)}
      </h2>
      <div className="overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-wrap items-end gap-x-3 gap-y-1 border-b border-gray-200 px-4 py-3.5 text-sm text-gray-900">
          <span className="text-lg leading-none font-semibold">
            {data.fullName}
          </span>
          <span>DOB: {data.dateOfBirth}</span>
          <span>{data.gender}</span>
        </div>
        <div className="flex flex-wrap gap-6 px-4 py-3.5">
          <div>
            <p className="text-sm leading-5 font-medium text-gray-500">Phone</p>
            <p className="text-sm leading-5 text-gray-900">{data.phone}</p>
          </div>
          <div>
            <p className="text-sm leading-5 font-medium text-gray-500">
              Address
            </p>
            <p className="text-sm leading-5 text-gray-900">{data.address}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
